import { Skeleton } from 'antd';
import { styled } from 'styled-components';
export const ShareButton = styled(Skeleton.Node).withConfig({
  displayName: "ShareButtonstyle__ShareButton",
  componentId: "sc-4cuced-0"
})(["", " svg{", "}img{", "}@media (max-width:", "){", "}"], {
  "height": "3rem !important",
  "width": "3rem !important",
  "minWidth": "0px !important",
  "borderRadius": "0.5rem !important"
}, {
  "display": "none"
}, {
  "opacity": "0.5"
}, ({
  theme
}) => theme.breakpoint.md, {
  "height": "2.5rem !important",
  "width": "2.5rem !important"
});